import React from "react";

export function RequiredAsterisk() {
  return (
    <span title="This field is required." className="text-red-500">
      *
    </span>
  );
}
